import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class NotificationTriggerCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        this.loadNotificationTriggers(this.props.userTypeCode);
    }

    loadNotificationTriggers = (userTypeCode) => {
        var rq = {
            userTypeCode: userTypeCode,
            notificationTypeCode: this.props.notificationTypeCode
        };
        API.App.get('/notificationSetup/getNotificationTriggers', rq,
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.name, value: item.notificationTriggerCode } }),
                    });
                }
            }, { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userTypeCode !== this.props.userTypeCode)
            this.loadNotificationTriggers(nextProps.userTypeCode);
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Trigger Event"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default NotificationTriggerCombo;

// Mark this as a form component
NotificationTriggerCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/notificationTriggerCombo/NotificationTriggerCombo.js